<template>
  <header class="navbar">
    <h1 class="navbar__title title-24">Мониторинг качества данных</h1>
    <nav class="navbar__menu">
      <!-- <a
        class="
          navbar__menu-item navbar__menu-item--to-the-main-application
          button button--secondary button--left-icon
        "
        href=""
        >В основное приложение</a
      > -->
      <a
        class="navbar__menu-item navbar__button-icon"
        aria-label="Помощь"
        title="Помощь"
        target="_blank"
        :href="manualURL"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 7.5C8 7.10218 8.18426 6.72064 8.51225 6.43934C8.84025 6.15804 9.2851 6 9.74895 6H10.2486C10.7125 6 11.1573 6.15804 11.4853 6.43934C11.8133 6.72064 11.9976 7.10218 11.9976 7.5C12.016 7.82463 11.9285 8.14645 11.7482 8.41699C11.568 8.68753 11.3047 8.89214 10.9982 9C10.6916 9.14382 10.4284 9.41663 10.2482 9.77735C10.0679 10.1381 9.9804 10.5672 9.9988 11"
            stroke="#465362"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 14V14.0083"
            stroke="#465362"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <circle
            cx="10"
            cy="10"
            r="7.5"
            stroke="#465362"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
      <!-- <button
        class="navbar__menu-item navbar__button-icon"
        aria-label="Личный кабинет"
        title="Личный кабинет"
      >
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="18"
            cy="17.25"
            r="5.25"
            stroke="#465362"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M31.5 18C31.5 21.6585 30.0447 24.9771 27.6814 27.4085C25.2285 29.9322 21.7973 31.5 18 31.5C14.2027 31.5 10.7715 29.9322 8.31856 27.4085C5.95529 24.9771 4.5 21.6585 4.5 18C4.5 10.5442 10.5442 4.5 18 4.5C25.4558 4.5 31.5 10.5442 31.5 18Z"
            stroke="#465362"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.3186 27.4085C10.5024 24.4322 14.0256 22.5 18 22.5C21.9745 22.5 25.4977 24.4322 27.6815 27.4085"
            stroke="#465362"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 6L8 10L12 6"
            stroke="#465362"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button> -->
    </nav>
  </header>
</template>

<script>
export default {
  setup() {
    const manualURL = 'https://nephrite.e-dag.ru:9006/help/user/usages/ias/ias.data.set/help.data.set.html#relation';

    return {
      manualURL
    }
  },
}
</script>


<style lang="scss">
@import "@/assets/sass/main.scss";

.navbar {
  display: flex;
  gap: 35px;
  align-items: center;
  justify-content: space-between;
  background-color: var(--basic-white);
  padding-left: var(--padding-container-desktop);
  padding-right: var(--padding-container-desktop);
  padding-top: 16px;
  padding-bottom: 16px;
}

.navbar__menu {
  display: flex;
  gap: 12px;
}

.navbar__menu-item--to-the-main-application::before {
  background-image: url("../../assets/svg/arrow-go-back.svg");
}

.navbar__button-icon {
  display: flex;
  align-items: center;
  padding: 0 4px;
  border-radius: 8px;
  border: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
}

.navbar__button-icon:hover path,
.navbar__button-icon:hover circle {
  stroke: var(--secondary-blue-darker);
}

.navbar__button-icon:focus path,
.navbar__button-icon:focus circle {
  stroke: var(--primary-blue);
}

.navbar__button-icon:active path,
.navbar__button-icon:active circle {
  stroke: var(--primary-blue-dark);
}

.navbar__button-icon:disabled path,
.navbar__button-icon:disabled circle {
  stroke: var(--basic-grey-dark);
}
</style>
